import CountUp from './CountUp'

// Key figure tile: label + metallic badge on top, the figure in the premium
// gradient below. A trailing "(MT)"-style unit in the label moves next to the
// figure so every label fits on one line.
const StatCard = ({ icon, label, value, onClick, style, className = '' }) => {
  const unitMatch = label.match(/^(.*?)\s*\(([^)]+)\)$/)
  const title = unitMatch ? unitMatch[1] : label
  const unit = unitMatch ? unitMatch[2] : null
  const Tag = onClick ? 'button' : 'div'
  // Long figures (e.g. "$1,245,310.50") step down so they never overflow the tile
  const length = String(value).length
  const valueSize = length >= 12 ? 'text-lg' : length >= 9 ? 'text-[22px]' : 'text-[28px]'

  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      style={style}
      className={`card-premium group flex flex-col p-4 text-left ${onClick ? 'card-premium-interactive' : ''} ${className}`}
    >
      <span className="flex w-full items-start justify-between gap-3">
        <span className="line-clamp-2 min-h-[2.25rem] pt-0.5 text-[11px] font-semibold uppercase leading-snug tracking-[0.06em] text-slate-500">
          {title}
        </span>
        <span className="badge-metallic h-8 w-8 text-sm">
          <i className={`bi ${icon}`}></i>
        </span>
      </span>

      <span className="mt-3 flex h-8 min-w-0 items-end gap-1.5">
        <span className={`text-premium font-bold leading-none tracking-tight tabular-nums ${valueSize}`}>
          <CountUp value={value} />
        </span>
        {unit && <span className="pb-0.5 text-xs font-semibold text-slate-400">{unit}</span>}
      </span>

      {onClick && (
        <span className="mt-3 flex items-center gap-1 text-xs font-medium text-slate-400 transition-colors group-hover:text-[#0a5fe0]">
          View details
          <i className="bi bi-arrow-right transition-transform duration-200 group-hover:translate-x-0.5"></i>
        </span>
      )}
    </Tag>
  )
}

export default StatCard
